var exports = {
  "k": "x31de4314--3fce0d--container",
};

module.exports = exports;
